import api from "@/api/api";
import {iniciarRequisicao, logout} from "@/helpers";
import {STATUS_HTTP} from "@/api/statusHTTP";

export const buscarPedidosCompras = async (params) => {
  const url = `compras/produtos/carrinho/pedidos`;
  const {data, status} = await api.post(url, params, {headers: iniciarRequisicao()}).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.pedidos;
  }

  logout();
}

export const buscarProdutosPedidoSelecionado = async (params) => {
  const url = `compras/produtos/carrinho/produtos`;
  const {data, status} = await api.get(url, {params, headers: iniciarRequisicao()}).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.produtos;
  }

  logout();
}

export const atualizarProdutoNoCarrinho = async (params) => {
  const url = `compras/produtos/carrinho/produtos`;
  const {data, status} = await api.put(url, params, {headers: iniciarRequisicao()}).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return true;
  }

  logout();
}

export const exluirProdutoDoCarrinho = async (params) => {
  const url = "compras/produtos/carrinho/produtos/exclusao";
  const {data, status} = await api.post(url, params, {headers: iniciarRequisicao()}).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data;
  }

  logout();
}

export const buscarFornecedoresPedido = async (id_pedido) => {
  const url = `compras/produtos/carrinho/pedidos/${id_pedido}/fornecedores`;
  const {data, status} = await api.get(url, {headers: iniciarRequisicao()}).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.fornecedores;
  }

  logout();
}

export const consolidarPedidos = async (params) => {
  const url = `compras/produtos/carrinho/pedidos/consolidar`;
  const {data, status} = await api.post(url, params, {headers: iniciarRequisicao()}).catch(() => logout());

  if (status === STATUS_HTTP.CREATED) {
    localStorage.token = data.token;
    return true;
  }

  logout();
}
